import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-disclaimer">
          <p>⚠️ <strong>Disclaimer:</strong> Analysis provided is for informational purposes only and does not constitute financial, investment, or real estate advice. Please consult with qualified professionals before making investment decisions.</p>
        </div>
        <div className="footer-bottom">
          <p className="copyright">© {new Date().getFullYear()} Property ROI Calculator</p>
          <div className="footer-links">
            <Link to="/terms" className="footer-link">Terms of Service</Link>
            <Link to="/privacy" className="footer-link">Privacy Policy</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
